import ConfigUtil from "core/util/config/ConfigUtil";
import { Entity, Field } from "typegraph";
import IService from "../IService";

@Entity({many: 'conditionsUser'})
export class RemoteCondition {
	@Field() public id: string;
	@Field() public externalId: string;
	@Field() public value: boolean;
}

export default abstract class IRemoteConditionService implements IService {
	public static REGISTRY = "service.remote.condition";

	public getRegistry(): string {
		return IRemoteConditionService.REGISTRY;
	}

	public getConditions() {
		return undefined;
	}

	public getActive() {
		return ConfigUtil.getString(IRemoteConditionService.REGISTRY, "default");
	}

	public abstract getServiceId(): string;
	public abstract evaluateConditions(externalIds: string[]): Promise<RemoteCondition[]>;
}



// WEBPACK FOOTER //
// ./src/core/service/remoteCondition/IRemoteConditionService.ts